import { useTranslation } from 'react-i18next';
import type { TaskStatus } from '@interfaces/IScheduler';
import { Pill } from '@components/ui/Pill/Pill';
import { STATUS_CLASS, STATUS_KEY } from '../../lib/statusLabels';
import statusStyles from '../_status.module.css';

export interface ITaskStatusPillProps {
  status: TaskStatus;
}

/** A plan task's status chip, in the Scheduler's own tones — so a task's status
 *  reads the same in its drawer, its subtask rows and on a delivery. */
export function TaskStatusPill({ status }: ITaskStatusPillProps) {
  const { t } = useTranslation();
  return <Pill className={statusStyles[STATUS_CLASS[status]]}>{t(`scheduler.status.${STATUS_KEY[status]}`)}</Pill>;
}
